import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './tailwind.output.css'
import * as serviceWorker from './serviceWorker'
import './utilities/cookies'

window.dataLayer = window.dataLayer || []

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
}

class Empty extends React.Component {
  render() {
    return <></>
  }
}

function AppLoader() {
  const [AppComponent, setAppComponent] = useState(() => Empty)

  useEffect(() => {
    async function load() {
      try {
        const response = await fetch('/config.json', { cache: 'no-store' })
        if (!response.ok) throw new Error('Failed to load config.json')
        window.__CONFIG__ = await response.json()

        const { default: App } = await import('./App')
        setAppComponent(() => App)
      } catch (err) {
        console.error('Failed to load config or App', err)
      }
    }

    load()
  }, [])

  return <AppComponent />
}

ReactDOM.render(<AppLoader />, document.getElementById('root'))
